import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { socket } from 'socket'

import {
  FiFilter,
  FiX,
  FiCheck,
  FiCircle,
  FiTarget
} from 'react-icons/fi'

import { AiOutlineClear } from 'react-icons/ai'

const EventFilter = ( { list } ) => {
  const [ searchParams, setSearchParams ] = useSearchParams()
  const [ isOpen, setIsOpen ] = useState( false )
  const [ eventList, setEventList ] = useState( [] )
  const [ points, setPoints ] = useState( [] )

  // useEffect( () => {
  //   console.log( { eventList } )
  // }, [ eventList ] )

  // useEffect( () => {
  //   console.log( { points } )
  // }, [ points ] )

  // add
  useEffect( () => {
    const handlePoint = ( data ) => {

      if ( data.event && data.event.identity ) {
        setEventList( eventList => {
          const inList = eventList.find( e => e.identity === data.event.identity )

          if ( inList )
            return eventList

          return [ ...eventList, data.event ]
        } )
      }

      setPoints( points => {
        const inList = points.find( p => p.user_id === data.user_id )

        if ( inList )
          return points

        return [ ...points, data ]
      } )

    }

    socket.on( 'point', handlePoint )

    return () => {
      socket.off( 'point', handlePoint )
    }

  }, [] )

  // destroy
  useEffect( () => {
    const destroyHandler = ( data ) => {
      console.log( { eventDestroy: data } )

      // points
      setPoints( points => {
        const pointAux = [ ...points ]
          .filter( p => p.user_id !== data.user_id )

        // events
        setEventList( eventList => {
          const eventAux = [ ...eventList ]
            .map( e => {

              const count = pointAux
                .filter( p => p.event )
                .filter( p => p.event.identity === e.identity )

              return {
                ...e,
                count: count.length
              }
            } )
            .filter( e => e.count > 0 )

          return eventAux
        } )

        return pointAux
      } )
    }

    socket.on( 'drop_pin', destroyHandler )

    return () => {
      socket.off( 'drop_pin', destroyHandler )
    }
  }, [ socket ] )

  const toggle = () => setIsOpen( ! isOpen )

  const cancel = () => toggle()

  const toggleEvent = ( index ) => {
    setEventList( eventList => {
      let aux = [ ...eventList ]

      const value = aux[ index ].selected

      aux[ index ].selected = ! value

      return aux
    } )
  }

  const togglePoint = ( index ) => {
    setPoints( points => {
      let aux = [ ...points ]

      const value = aux[ index ].selected

      aux[ index ].selected = ! value

      return aux
    } )
  }

  const apply = () => {

    // events
    const eventIds = eventList
      .filter( e => e.selected )
      .map( e => e.identity )

    // points / person
    const pointsIds = points
      .filter( p => p.selected )
      .map( p => p.user_id )

    setSearchParams( searchParams => {
      if ( eventIds.length > 0 )
        searchParams.set( 'events', JSON.stringify( eventIds ) )
      else 
        searchParams.delete( 'events' )

      if ( pointsIds.length > 0 )
        searchParams.set( 'points', JSON.stringify( pointsIds ) )
      else
        searchParams.delete( 'points' )

      return searchParams
    } )

    toggle()
  }

  const clear = () => {
    setEventList( eventList => {
      return eventList
        .map( e => ( { ...e, selected: false } ) )
    } )

    setPoints( points => {
      return points
        .map( p => ( { ...p, selected: false } ) )
    } )

    setSearchParams( searchParams => {
      searchParams.delete( 'events' )
      searchParams.delete( 'points' )

      return searchParams
    } )

    toggle()
  }

  return <>
    <button
      title="filtrar"
      onClick={ toggle }
    >
      <FiFilter />
    </button>

    { isOpen ? <div
      className="modal full hs"
    >
      <div className="bar">
        <h1>encuadrar</h1>

        <button
          title="aplicar"
          onClick={ apply }
        >
          <FiCheck />
        </button>

        <button
          title="borrar"
          onClick={ clear }
        >
          <AiOutlineClear />
        </button>

        <button
          title="cancelar"
          onClick={ cancel }
        >
          <FiX />
        </button>
      </div>

      { /* events */ }
      <div className="scroll one hs in-air-2x">
        <ul className="list-menu">
          { eventList.map(
            ( item, index ) => <li
              key={ index }
              className="list-item"
              onClick={ () => toggleEvent( index ) }
            >
              <span className="icon">
                { item.selected ?
                <FiTarget /> :
                <FiCircle /> }
              </span>

              <span className="text">
                { item.name }
              </span>
            </li>
          ) }
        </ul>
      </div>

      { /* points */ }
      <div className="scroll one hs in-air-2x">
        <ul className="list-menu">
          { points.map(
            ( item, index ) => <li
              key={ index }
              className="list-item"
              onClick={ () => togglePoint( index ) }
            >
              <span className="icon">
                { item.selected ?
                <FiTarget /> :
                <FiCircle /> }
              </span>

              <span className="text">
                { item.label }
              </span>
            </li>
          ) }
        </ul>
      </div>
    </div> : null }
  </>
}

export default EventFilter
